
import { defineComponent } from "vue";
import { Ad } from "../types";
import { useToast } from "vue-toastification";
const toast = useToast();

export default defineComponent({
  name: "TxStreetApi",
  methods: {
    //BodyInit and RequestInit throwing errors
    async apiCall(url: string, method = "GET", body: any | null = null): Promise<any> {
      url = this.$store.state.apiBase + url;
      const request: any = {
        method: method,
      };
      if (body) {
        request.body = body;
        if (method == "POST") {
          request.headers = {
            Accept: "application/json",
            "Content-Type": "application/json",
          };
        }
      }
      const promise = fetch(url, request);
      const response = promise
        .then(async (res) => {
          if (res.status == 429) {
            toast.error("Slow down! Try again in a minute.");
            return false;
          }
          if (res.ok) {
            let json = await res.json();
            if (json.error) toast.error(json.error);
            return json;
          }
          return;
        })
        .catch((error) => {
          toast.error(error.message);
          return false;
        });
      return response;
    },
    async getCharacterId() {
      let url = "/api/getCharacter/" + this.$store.state.connectedAddress;
      let result = await this.apiCall(url);
      if (result) {
        this.$store.commit("changeTxStreetCharacter", result);
        return result;
      }
    },
    async getForSale() {
      let url = "/api/getForSale";
      let result = await this.apiCall(url);
      if (result) {
        console.log(result);
        // this.forSale = result;
        return result;
      }
    },
    async createAd(address: string, ad: Ad, signature: string) {
      let url = "/api/reserveAd";
      let result = await this.apiCall(
        url,
        "POST",
        JSON.stringify({ address: address, message: ad, signature: signature })
      );
      if (result) {
        // this.forSale = result;
        return result;
      }
    },
    async getAdWait(ids: number[]) {
      let url = "/api/adWait/" + JSON.stringify(ids);
      let result = await this.apiCall(url);
      if (result) {
        // this.forSale = result;
        for (const tokenId in result) {
          const waitTime = result[tokenId];
          this.$store.commit("setAdWaitTime", waitTime);
        }
      }
      return result;
    },
    getAttribute(info: any, name: string) {
      let value = 0;
      for (let i = 0; i < info.attributes.length; i++) {
        const att = info.attributes[i];
        if (att.trait_type === name) {
          value = att.value;
          break;
        }
      }
      return value;
    },
  },
});
